$('html').on('session:pinged', () => {
  const dismissModal = () => {
    $('.js-modal').hide();
  };

  $('.js-modal-hide').on('click', dismissModal);
});
